export const default_helper_bindings = {
	codes: "Code",
	dispatcher: "Dispatcher",
	yieldable: "ToEffect",
	scope: "__SER___scope",
} as const;
